export const PIX_ISSUER_ID = '62';
export const PIX_ISSUER_ID_NAME = 'PIX';
export const PIX_PAYMENT_METHOD_NAME = 'Pix';
// Restaurante Fasano las Piedras: 30367
export const ONLY_DOLLARS_AND_TEN_PERCENT_TIP_RESTAURANTS = [
  { restaurantId: 30367, currency: 'USD', tipPercentage: '10%' },
];
// Commerces hidden from selection dropdown but accessible via direct payment link
// Puntammiami Hotel: 20108
export const HIDDEN_FROM_SELECTION_COMMERCES = [20108];
// Commerces excluded from European Bank Transfer option
export const EUROPE_BANK_TRANSFER_EXCLUDED_COMMERCES = [38094, 35832, 38095, 60923];
